module.exports = __webpack_public_path__ + "assets/img/demo-home.fa06df3b.png";